import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '@libs/common/components';
import { AuthService } from '@libs/shared/auth';
import { firstValueFrom } from 'rxjs';
import { AgentSearchComponent } from './agent-search';

@Component({
  selector: 'ui-agent',
  imports: [
    ButtonComponent,
    ReactiveFormsModule,
    AgentSearchComponent,
  ],
  templateUrl: './agent.component.html',
  styleUrl: './agent.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentComponent {
  public readonly authService: AuthService = inject(AuthService);

  public logout(): Promise<void> {
    return firstValueFrom(this.authService.logout());
  }
}
